<script>
  // @ts-nocheck
  import { fade, fly, slide } from "svelte/transition";
  import BasketPage from "$lib/components/BasketPage.svelte";
  import AlertAuth from "$lib/components/AlertAuth.svelte";
  import SuccesWatchList from "$lib/components/SuccesWatchList.svelte";
  import { goto } from "$app/navigation";
  import { basketListnew, basketId } from "$lib/store/newbasket";
  import Loader from "$lib/components/Loader.svelte";

  import { page } from "$app/stores";
  import { favoritesList } from "$lib/store/favorites";
  import { basketList } from "$lib/store/basket";
  import like from "$lib/images/like.svg";
  import Activelike from "$lib/images/activeLike.svg";
  export let reload, item, ind;
  import { env as public_env } from "$env/dynamic/public";
  import prev from "$lib/images/rig.svg";
  import next from "$lib/images/left.svg";
  import { variables } from "$lib/variables";
  import GalleryCart from "./GalleryCart.svelte";
  import { lang } from "$lib/translations/cartproduct";
  import AddBasketSucces from "./AddBasket.svelte";
  import Sign from "./Sign.svelte";
  import ConfirmSize from "./ConfirmSize.svelte";
  let openConfirmAddWatchListSize = false;
  let openalertauth = false;
  let hoverActive = false;

  $: AddFavorites =
    $favoritesList.filter(function (e) {
      return e.item.id == item.id;
    }).length > 0;
  function handleClickGalleryPrev() {
    let index = item.photos.indexOf(activeImage);
    activeImage = null;

    if (index === 0) {
      // Если текущее изображение - первое в списке, переходите к последнему
      activeImage = item.photos[item.photos.length - 1];
    } else {
      // Иначе переходите к предыдущему изображению
      activeImage = item.photos[index - 1];
    }
  }
  function handleClickGalleryNext() {
    let index = item.photos.indexOf(activeImage);
    activeImage = null;

    if (index === item.photos.length - 1) {
      // Если текущее изображение - последнее в списке, переходите к первому
      activeImage = item.photos[0];
    } else {
      // Иначе переходите к следующему изображению
      activeImage = item.photos[index + 1];
    }
  }
  function AddFavorite() {
    if (
      $favoritesList.filter(function (e) {
        return e.item.id == item.id;
      }).length > 0
    ) {
      let new_arr = $favoritesList.filter((e) => {
        return e.item.id != item.id;
      });
      $favoritesList = [...new_arr];
    } else {
      $favoritesList = [
        ...$favoritesList,
        {
          item,
        },
      ];
    }

    setTimeout(() => {
      localStorage.setItem("favorites", JSON.stringify($favoritesList));
    }, 500);
  }

  item.photos.sort((a, b) => {
    if (a.home_image && !b.home_image) {
      return -1;
    }
    if (!a.home_image && b.home_image) {
      return 1;
    }
    return 0;
  });

  let activeImage = item.photos[0];
  let discountPercentage;
  if (Number(item.sale_price) != 0) {
    discountPercentage = ((item.price - item.sale_price) / item.price) * 100;
  }
  let OpenBasket = false;
  async function GetBasket(pk) {
    let url = `${variables.basePathApi}/api/v1/orders/${pk}/`;
    const res = await fetch(url);
    $basketListnew = await res.json();
  }
  async function GetBasketNew() {
    let urls = `${variables.basePathApi}/api/v1/orders/user-auth/`;
    if ($page.data.access) {
      const res = await fetch(urls, {
        headers: {
          Authorization: "Bearer " + $page.data.access,
        },
      });
      if (res.status === 200) {
        let baskData = await res.json();
        const resLogin = await fetch("/create-basket-cookie", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ basketId: baskData.id }),
        });
        if (resLogin.status == 200) {
          $basketListnew = baskData;
          $basketId = baskData.id;
          AddBasket();
        }
      }
    } else {
      const res = await fetch(urls, {});
      if (res.status === 200) {
        let baskData = await res.json();
        const resLogin = await fetch("/create-basket-cookie", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ basketId: baskData.id }),
        });
        if (resLogin.status == 200) {
          $basketListnew = baskData;
          $basketId = baskData.id;
          AddBasket();
        }
        $basketListnew = baskData;
        $basketId = baskData.id;
      }
    }
  }
  async function AddWatchList(product_attribute_id) {
    console.log(123445);
    let url = `${variables.basePathApi}/api/v1/add-to-wishlist/`;
    if ($page.data.access) {
      openConfirmAddBasketSize = false;
      let data = { product_attribute_id: product_attribute_id };
      load = true;
      let method = "POST";
      const res = await fetch(url, {
        method: method,
        headers: {
          Authorization: "Bearer " + $page.data.access,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      // const res = await fetch(urls, {
      //   method: "POST",
      //   headers: {
      //     Accept: "application/json",
      //     "Content-Type": "application/json",
      //     Authorization: "Bearer " + $page.data.access,
      //     body: JSON.stringify({ product_attribute_id: product_attribute_id }),
      //   },
      // });
      if (res.status === 201 || res.status === 200) {
        let data = await res.json();
        if (data.message) {
          opensuccess = true;
          messagetext = data.message;
        }
      }
      load = false;
    } else {
      openConfirmAddBasketSize = false;
      openalertauth = true;
    }
  }
  async function AddBasket() {
    if (!$basketId) {
      return GetBasketNew();
    }

    load = true;

    if (
      $basketListnew?.order_items.filter((el) => {
        return el.product.id === item.id;
      }).length
    ) {
      load = false;
      return (OpenBasket = true);
    }
    let data = {
      user: $page.data.user?.id,
      phone: $page.data.user?.phone || "",
      email: $page.data.user?.email || "",
      street: $page.data.user?.street || "",
      fio: $page.data.user?.fio || "",
      fname: $page.data.user?.fname || "",
      oname: $page.data.user?.oname || "",
      name: $page.data.user?.name || "",
      city: $page.data.user?.city || "",
      region: $page.data.user?.region || "",
      index: $page.data.user?.index || "",
      address: "",
      house: $page.data.user?.house || "",
      kv: $page.data.user?.kv || "",
      order_items: [
        {
          product: item.id,
          total: 1,
        },
      ],
    };
    let url = `${variables.basePathApi}/api/v1/orders/`;
    let method = "POST";

    if ($basketId) {
      url = `${variables.basePathApi}/api/v1/orders/${$basketId}/`;
      method = "PUT";
    }
    const res = await fetch(url, {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (res.status === 201 || res.status === 200) {
      let payload = await res.json();

      localStorage.setItem("basketId", payload.id);
      $basketId = payload.id;
      await GetBasket(payload.id);
      load = false;
    }
    load = false;
    SuccesMessage3 = true;
    return;
  }
  async function AddBasketVariant(variant_id) {
    openConfirmAddBasketSize = false;

    if (!$basketId) {
      return GetBasketNew();
    }

    load = true;

    if (
      $basketListnew?.order_items.filter((el) => {
        return el.product.id === variant_id;
      }).length
    ) {
      load = false;
      return (OpenBasket = true);
    }
    let data = {
      user: $page.data.user?.id,
      phone: $page.data.user?.phone || "",
      email: $page.data.user?.email || "",
      street: $page.data.user?.street || "",
      fio: $page.data.user?.fio || "",
      fname: $page.data.user?.fname || "",
      oname: $page.data.user?.oname || "",
      name: $page.data.user?.name || "",
      city: $page.data.user?.city || "",
      region: $page.data.user?.region || "",
      index: $page.data.user?.index || "",
      address: "",
      house: $page.data.user?.house || "",
      kv: $page.data.user?.kv || "",
      order_items: [
        {
          product: variant_id,
          total: 1,
        },
      ],
    };
    let url = `${variables.basePathApi}/api/v1/orders/`;
    let method = "POST";

    if ($basketId) {
      url = `${variables.basePathApi}/api/v1/orders/${$basketId}/`;
      method = "PUT";
    }
    const res = await fetch(url, {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (res.status === 201 || res.status === 200) {
      let payload = await res.json();

      localStorage.setItem("basketId", payload.id);
      $basketId = payload.id;
      await GetBasket(payload.id);
      load = false;
    }
    load = false;
    SuccesMessage3 = true;
    return;
  }
  let load = false;
  let SuccesMessage3 = false;
  let signin = false;
  let openAlert = false;
  let openConfirmAddBasketSize = false;
  let opensuccess = false;
  let messagetext = "";
</script>

{#if openConfirmAddBasketSize}
  <ConfirmSize
    {item}
    bind:openConfirmAddBasketSize
    {AddBasketVariant}
    {AddWatchList}
  />
{/if}

{#if signin}
  <Sign bind:signin />
{/if}
{#if SuccesMessage3}
  <AddBasketSucces bind:SuccesMessage3 {item} />
{/if}
{#if load}
  <Loader />
{/if}
{#if openalertauth}
  <AlertAuth bind:openalertauth />
{/if}
{#if opensuccess}
  <SuccesWatchList bind:opensuccess {messagetext} />
{/if}
{#if OpenBasket}
  <BasketPage bind:OpenBasket />
{/if}

<!-- svelte-ignore a11y-missing-content -->
{#if item.photos && item.photos.length}
  <a
    rel={reload ? "external" : ""}
    href="/{item.product.category.slug}/{item.id}"
    on:mouseenter={() => {
      hoverActive = true;
    }}
    on:mouseleave={() => {
      hoverActive = false;
    }}
    class:custom-white-bg={hoverActive}
    class:bg-custom-gray-bg={!hoverActive}
    class="h-full md:pl-[40px] md:pr-[40px] pr-[27px] pl-[27px] relative placeholder"
  >
    <!-- Favorite & sale % -->
    <div class="grid mt-[29px] grid-cols-2">
      <div class="text-start">
        {#if item.akcia}
          <div
            style="background-color: {item.akcia.color};"
            class="absolute left-0 top-0 text-[10px] text-white font-bold py-1 px-4"
          >
            {item.akcia[`name${$page.data.host}`]}
          </div>
        {/if}
        {#if Number(item.sale_price) != 0 && !item.akcia}
          <span class="text-custom-gray text-sm">
            <!-- -{discountPercentage.toFixed(0)}% -->
            -{Number(discountPercentage).toFixed(0)}%
          </span>
        {/if}
      </div>
      <div class="text-end">
        <button on:click|stopPropagation|preventDefault={AddFavorite}>
          {#if AddFavorites}
            <img
              style="width: 30px;height: 21px;"
              width="30"
              height="21"
              src={Activelike}
              alt="like"
            />
          {:else}
            <img
              style="width: 30px;height: 21px;"
              width="30"
              height="21"
              src={like}
              alt="like"
            />
          {/if}
        </button>
      </div>
    </div>
    <!-- Image -->
    <div
      class="flex relative h-[250px] md:min-h-[336px] min-w-full justify-center items-center"
    >
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div
        on:click|stopPropagation|preventDefault={() => {}}
        transition:fade
        class="relative"
      >
        <GalleryCart
          {reload}
          items={item.photos}
          {hoverActive}
          link={`/${item.product.category.slug}/${item.id}`}
          product={item}
        />
      </div>
    </div>

    <!-- Text1 -->
    <div
      style=""
      class="grid mb-[32px] mt-[13px] grid-cols-1 md:grid-cols-2 h-[16vh] md:h-[10vh]"
    >
      <!-- Title -->
      <div class="text-center md:text-start min-h-[15vh] md:min-h-max">
        <button class="text-sm md:text-start text-center text-custom-black"
          >{item.product[`name${$page.data.host}`]}
          {#if item.color}
            <p class="mb-2 mt-2">
              <span class="text-gray-600"
                >{lang[$page.data.host]["colortile"]}:
              </span>
              {item.color[`name${$page.data.host}`]}
            </p>
          {/if}
          <!-- {#if item.sizes}
					<p class="mb-2">
						<span class="text-gray-600">{lang[$page.data.host]['sizetile']}: </span>
						{item.sizes.european || item.sizes.international}
					</p>
				{/if} -->
        </button>
      </div>
      <!-- Price -->
      <div class="text-center mt-8 md:mt-0 md:text-end">
        {#if !item.pre_order}
          {#if Number(item.sale_price) != 0}
            <span class="text-sm text-custom-black">
              <span style="font-weight: 600;"
                >{Number(item.sale_price).toLocaleString("ru")}</span
              >
              ₽
            </span>
            <span class="text-sm mr-[4px] line-through text-custom-gray">
              {Number(item.price).toLocaleString("ru")}
              ₽
            </span>
          {:else}
            <span class="text-sm mr-[4px] text-custom-black">
              <span style="font-weight: 600;"
                >{Number(item.price).toLocaleString("ru")}</span
              >
              ₽
            </span>
          {/if}
          <!-- {:else}
			{Number(item.price_pre_order).toLocaleString('ru')} ₽
			<p>{Number(item.price).toLocaleString('ru')} ₽</p> -->
        {/if}
      </div>
    </div>

    <!-- svelte-ignore missing-declaration -->
    {#if !item.pre_order}
      {#if item.total > 0}
        <div class="w-full h-[8vh]" />
        <button
          on:mouseenter={() => {
            hoverActive = true;
          }}
          on:mouseleave={() => {
            hoverActive = false;
          }}
          on:click|stopPropagation|preventDefault={() => {
            // AddBasket();
            if (
              item.get_sizes_origin_product.length === 0 ||
              item.get_sizes_origin_product.length === 1
            ) {
              AddBasket();
            } else {
              // location.href = `/${item.product.category.slug}/${item.id}`;
              openConfirmAddBasketSize = true;
            }
          }}
          class:border-custom-black={!hoverActive}
          class:border-bg-custom-gray3={hoverActive}
          class:text-custom-white-bg={$basketListnew?.order_items.filter(
            (el) => {
              return el.product.id === item.id;
            }
          ).length > 0}
          class:bg-custom-gray3={$basketListnew?.order_items.filter((el) => {
            return el.product.id === item.id;
          }).length > 0}
          class="w-full mt-10 mb-4 md:h-12 h-10 border-solid border-1 hover:bg-custom-gray3 hover:text-custom-white-bg md:py-[14px] py-[8px] text-[10px] font-semibold text-center"
        >
          {#if !$basketListnew?.order_items.filter((el) => {
            return el.product.id == item.id;
          }).length}
            <span>{lang[$page.data.host]["addbaskettile"]}</span>
          {:else}
            <span>{lang[$page.data.host]["tobaskettile"]}</span>
          {/if}
        </button>
      {:else}
        <div class="w-full h-[8vh]" />
        <button
          on:mouseenter={() => {
            hoverActive = true;
          }}
          on:mouseleave={() => {
            hoverActive = false;
          }}
          on:click|stopPropagation|preventDefault={() => {
            // AddBasket();
            if (
              item.get_sizes_origin_product.length === 0 ||
              item.get_sizes_origin_product.length === 1
            ) {
              AddWatchList(item.id);
            } else {
              // location.href = `/${item.product.category.slug}/${item.id}`;
              return (openConfirmAddBasketSize = true);
            }
          }}
          class:border-custom-black={!hoverActive}
          class:border-bg-custom-gray3={hoverActive}
          class="w-full mt-10 mb-4 md:h-12 h-10 border-solid border-1 hover:bg-custom-gray3 hover:text-custom-white-bg md:py-[14px] py-[8px] text-[10px] font-semibold text-center"
        >
          в лист ожидания
        </button>
      {/if}
    {:else}
      <div class="w-full h-[8vh]">
        <div class="flex w-full justify-between items-center">
          <!-- <span class="text-sm w-[50%]">Стоимость</span>
				<div class="text-sm w-[50%">~ {Number(item.price).toLocaleString('ru')} ₽</div> -->
        </div>
        <div class="flex justify-between items-center">
          <span class="text-sm w-[50%">Предзаказ</span>
          <div class="text-sm w-[50%">
            {Number(item.price_pre_order).toLocaleString("ru")} ₽
          </div>
        </div>
      </div>
      <button
        on:mouseenter={() => {
          hoverActive = true;
        }}
        on:mouseleave={() => {
          hoverActive = false;
        }}
        on:click|stopPropagation|preventDefault={() => {
          if (!$page.data.user) {
            openAlert = true;
          } else {
            if (item.get_sizes_origin_product.length > 1) {
              return (openConfirmAddBasketSize = true);
            } else {
              AddBasket();
            }
          }
          // if (!item.sizes) {
          // 	AddBasket();
          // } else {
          // 	location.href = `/${item.product.category.slug}/${item.id}`;
          // 	// openConfirmAddBasketSize = true;
          // }
        }}
        class:border-custom-black={!hoverActive}
        class:border-bg-custom-gray3={hoverActive}
        class:text-custom-white-bg={$basketListnew?.order_items.filter((el) => {
          return el.product.id === item.id;
        }).length > 0}
        class:bg-custom-gray3={$basketListnew?.order_items.filter((el) => {
          return el.product.id === item.id;
        }).length > 0}
        class="w-full mt-10 mb-4 md:h-12 h-10 border-solid border-1 hover:bg-custom-gray3 hover:text-custom-white-bg md:py-[14px] py-[8px] text-[10px] font-semibold text-center"
      >
        Оформить предзаказ
      </button>
    {/if}
  </a>
{/if}

{#if openAlert}
  <div
    class="relative z-[2000]"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div
        class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
      >
        <div
          class="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
        >
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <h3
                class="text-base font-semibold leading-6 text-gray-900"
                id="modal-title"
              >
                Внимание
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Для оформления покупок предзаказа необходима авторизация.
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              on:click={() => {
                signin = true;

                goto(`?pathname=${$page.url.pathname}`);
              }}
              type="button"
              class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >Войти</button
            >
            <button
              on:click={() => {
                openAlert = false;
              }}
              type="button"
              class="inline-flex w-full mr-3 mt-3 md:mt-0 justify-center rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
              >Отмена</button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}
